import { IPatientDevice } from '../models/device';
import { IResult } from '../models/result-models';
import { apiGet, apiPost } from './api-utils';
import {
    PrintWarrantyRequestDTO,
    WarrantyInfoResponseDTO,
    WarrantySubmitRequest,
} from '../models/warranty-center';

const baseUrl = process.env.REACT_APP_API_URL + '/v1/device';
const servicesBaseUrl = process.env.REACT_APP_SERVICES_URL;
const warrantySubmitUrl = baseUrl + '/WarrantyRequest';
const warrantySubmitUrlOld = servicesBaseUrl + '/forms/warranty';

export const getDevice = async (
    serialNumber: string
): Promise<IResult<IPatientDevice>> => {
    const result = await apiGet<IPatientDevice>(
        baseUrl + '/device-details/' + serialNumber
    );
    return result;
};

export const getDeviceWarrantySummaryFileName = async (
    dto: PrintWarrantyRequestDTO
): Promise<IResult<WarrantyInfoResponseDTO>> => {
    const url =
        servicesBaseUrl +
        '/forms/WarrantySummaryFileName?s1=' +
        dto.serialNumber1 +
        '&s2=' +
        dto.serialNumber2 +
        '&fn=' +
        dto.firstName +
        '&ln=' +
        dto.lastName +
        '&ph=' +
        dto.phoneNumber +
        '&ds=&ac=' +
        dto.account;
    const result = await apiGet<WarrantyInfoResponseDTO>(url);
    return result;
};

export const submitWarrantyRequest = async (
    dto: WarrantySubmitRequest
): Promise<IResult<boolean>> => {
    const result = await apiPost<WarrantySubmitRequest, boolean>(
        warrantySubmitUrlOld,
        dto
    );
    return result;
};
